var Cart = {
    postAddedToCart: function(response) {
        if (response.success) {
            ub.data.addedToCart = true;
            render = SummaryPreviewPanel.events.showAlertMessage("Your design added successfully", "success");
            $(".cart-container .add-to-cart").addClass("uk-disabled");
        } else {
            if (typeof response.message !== "undefined" && response.message.length > 0) {
                render = SummaryPreviewPanel.events.showAlertMessage(response.message, "danger");
            } else {
                render = SummaryPreviewPanel.events.showAlertMessage("Please add an item in your roster.", "danger");
            }
        }

        $(".cart-container .message-container").html("");
        $(".cart-container .message-container").html(render);

        SummaryPreviewPanel.events.hideLoader();
        SummaryPreviewPanel.events.hideMessage();
    },

    addCart: function(data) {
        SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
            if (response.success) {
                var design_number = ub.current_material.settings.savedDesignID;
                data.design_number = design_number;
                data.image_url = ub.current_material.settings.thumbnails.front_view;
                data.design_url = ub.config.magentoURL + "/uniform-saved-design/" + design_number;

                if (typeof ub.current_material.settings.thumbnailsLowRes !== "undefined") {
                    if (ub.current_material.settings.thumbnailsLowRes.front_view !== "undefined") {
                        data.image_url = ub.current_material.settings.thumbnailsLowRes.front_view;
                    }
                }

                if (ub.config.addCartJson !== "1" || ub.config.addCartJson === "") {
                    Cart.addToCartViaJSONP(data);
                } else {
                    var postMessageData = {
                        action: "add_to_cart",
                        data: data
                    };

                    parent.postMessage(postMessageData, ub.config.magentoURL);
                }
            } else {
                var message = "Something went wrong while updating design! Please try again.";
                ub.funcs.showNotification(message, "danger", 3000);
                UIkit.modal("#richardson-saving-option").hide();
            }
        }, function(error) {
            var message = "Something went wrong while updating design! Please try again.";
            ub.funcs.showNotification(message, "danger", 3000);
            UIkit.modal("#richardson-saving-option").hide();
        });
    },

    addToCartViaJSONP: function(data) {
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        $.ajax({
            url: ub.config.magentoURL + "/saveandshare/index/uniformProductConfiguration",
            data: data,
            type: "POST",
            crossDomain: true,
            dataType: 'jsonp',
            success: function (response) {
                var render;
                if (response.status) {
                    render = DesignPreview.events.showAlertMessage("Your design added successfully", "success");
                    $(".cart-container .add-to-cart").addClass("uk-disabled");
                    var obj = {
                        "action": "update_cart",
                        "count": response.cartCount
                    };
                    parent.postMessage(obj, ub.config.magentoURL);
                    ub.data.addedToCart = true;
                } else {
                    render = DesignPreview.events.showAlertMessage(response.message, "danger");
                }

                $(".cart-container .message-container").html("");
                $(".cart-container .message-container").html(render);
                DesignPreview.events.hideLoader();
                DesignPreview.events.hideMessage();
            },

            error: function(err) {
                DesignPreview.events.hideLoader();
            }
        });
    }
}